// extracted by mini-css-extract-plugin
export default {"list":"data-list_list__6LXY1","show":"data-list_show__zFdP5","item":"data-list_item__Qo0Tu","active":"data-list_active__AxH38","empty":"data-list_empty__8UkO7"};